import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withKeys as _withKeys, vModelText as _vModelText, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "o-container -container-max" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "o-filter__accordion__toggler__text" }, " Filtrer les résultats ", -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "o-filter__accordion__toggler__icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    "aria-hidden": "true",
    focusable: "false",
    class: "o-ico"
  }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/app/themes/baserock/assets/img/sprite.svg?v=2024#filter" })
  ])
], -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "o-filter__accordion__content" }
const _hoisted_6 = { class: "o-filter__accordion__content__inner" }
const _hoisted_7 = { class: "o-filter u-color-1 u-bg-color-1-lightest" }
const _hoisted_8 = { class: "o-form__wrap" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer-sm" }, null, -1 /* HOISTED */)
const _hoisted_10 = { class: "o-flex" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer-line" }, null, -1 /* HOISTED */)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "o-subtitle" }, " Type d’auteur.e.s ", -1 /* HOISTED */)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer-sm" }, null, -1 /* HOISTED */)
const _hoisted_15 = { class: "o-flex -flex-gap" }
const _hoisted_16 = { class: "o-flex__item" }
const _hoisted_17 = { class: "o-toggle" }
const _hoisted_18 = { class: "o-toggle__input__wrap" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "o-toggle__toggler" }, null, -1 /* HOISTED */)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  class: "o-toggle__label",
  for: "toggle-1"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "o-toggle__label__text" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      "aria-hidden": "true",
      focusable: "false",
      class: "o-ico"
    }, [
      /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/app/themes/baserock/assets/img/sprite.svg?v=2024#puzzle" })
    ]),
    /*#__PURE__*/_createTextVNode(" Jeunesse ")
  ])
], -1 /* HOISTED */)
const _hoisted_21 = { class: "o-flex__item" }
const _hoisted_22 = { class: "o-toggle" }
const _hoisted_23 = { class: "o-toggle__input__wrap" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "o-toggle__toggler" }, null, -1 /* HOISTED */)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  class: "o-toggle__label",
  for: "toggle-2"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "o-toggle__label__text" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      "aria-hidden": "true",
      focusable: "false",
      class: "o-ico"
    }, [
      /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/app/themes/baserock/assets/img/sprite.svg?v=2024#region" })
    ]),
    /*#__PURE__*/_createTextVNode(" Auteur.e.s de la région ")
  ])
], -1 /* HOISTED */)
const _hoisted_26 = { class: "o-flex__item" }
const _hoisted_27 = { class: "o-toggle" }
const _hoisted_28 = { class: "o-toggle__input__wrap" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "o-toggle__toggler" }, null, -1 /* HOISTED */)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", {
  class: "o-toggle__label",
  for: "toggle-3"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "o-toggle__label__text" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      "aria-hidden": "true",
      focusable: "false",
      class: "o-ico"
    }, [
      /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/app/themes/baserock/assets/img/sprite.svg?v=2024#paint" })
    ]),
    /*#__PURE__*/_createTextVNode(" Illustrateur.ice.s ")
  ])
], -1 /* HOISTED */)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer-line" }, null, -1 /* HOISTED */)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "o-subtitle" }, " Recherchez ", -1 /* HOISTED */)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer-sm" }, null, -1 /* HOISTED */)
const _hoisted_34 = { class: "o-flex -flex-gap -flex-space-between" }
const _hoisted_35 = { class: "o-flex__item" }
const _hoisted_36 = { class: "o-flex -flex-gap-xs -flex-wrap o-form-group" }
const _hoisted_37 = { class: "o-flex__item" }
const _hoisted_38 = { class: "o-form-group__item" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", {
  class: "o-label sr-only",
  for: "recherche"
}, "Recherche", -1 /* HOISTED */)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  class: "o-ico o-input__icon"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/app/themes/baserock/assets/img/sprite.svg?v=2024#search" })
], -1 /* HOISTED */)
const _hoisted_41 = { class: "o-flex__item" }
const _hoisted_42 = { class: "o-form-group__item" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", {
  class: "o-label sr-only",
  for: "date"
}, "Date", -1 /* HOISTED */)
const _hoisted_44 = { class: "o-select__wrap" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Date", -1 /* HOISTED */)
const _hoisted_46 = ["value"]
const _hoisted_47 = { class: "o-flex__item -flex-align-self-end" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer-line" }, null, -1 /* HOISTED */)
const _hoisted_49 = { class: "o-flex -flex-wrap -flex-gap-xxs" }
const _hoisted_50 = { class: "o-flex__item" }
const _hoisted_51 = { class: "o-filter__active" }
const _hoisted_52 = { class: "o-filter__active__text" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  class: "o-ico"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/app/themes/baserock/assets/img/sprite.svg?v=2024#close" })
], -1 /* HOISTED */)
const _hoisted_55 = [
  _hoisted_54
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["o-filter__accordion", {'is-open': $data.isOpen}])
    }, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = $event => ($data.isOpen=!$data.isOpen)),
        class: "o-filter__accordion__toggler"
      }, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("form", {
                class: "o-form",
                onSubmit: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"]))
              }, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.alphabet, (letter) => {
                    return (_openBlock(), _createElementBlock("button", {
                      class: _normalizeClass(["-text-bold", {'is-active': $data.selectedLetter==letter}]),
                      onClick: _withModifiers($event => ($options.toggleLetter(letter)), ["prevent"])
                    }, _toDisplayString(letter), 11 /* TEXT, CLASS, PROPS */, _hoisted_11))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ]),
                _hoisted_12,
                _hoisted_13,
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _withDirectives(_createElementVNode("input", {
                          class: "o-toggle__input",
                          type: "checkbox",
                          id: "toggle-1",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.isJeunesse) = $event)),
                          value: "1"
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelCheckbox, $data.isJeunesse]
                        ]),
                        _hoisted_19
                      ]),
                      _hoisted_20
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _withDirectives(_createElementVNode("input", {
                          class: "o-toggle__input",
                          type: "checkbox",
                          id: "toggle-2",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.isMauricie) = $event)),
                          value: "1"
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelCheckbox, $data.isMauricie]
                        ]),
                        _hoisted_24
                      ]),
                      _hoisted_25
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _withDirectives(_createElementVNode("input", {
                          class: "o-toggle__input",
                          type: "checkbox",
                          id: "toggle-3",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.isIllustrateur) = $event)),
                          value: "1"
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelCheckbox, $data.isIllustrateur]
                        ]),
                        _hoisted_29
                      ]),
                      _hoisted_30
                    ])
                  ])
                ]),
                _hoisted_31,
                _hoisted_32,
                _hoisted_33,
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _hoisted_39,
                          _withDirectives(_createElementVNode("input", {
                            onKeyup: _cache[4] || (_cache[4] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                            onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                            class: "o-input -input-has-icon",
                            type: "text",
                            id: "prenom",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($data.searchInput) = $event)),
                            placeholder: "Mots-clés ex. Roman"
                          }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                            [_vModelText, $data.searchInput]
                          ]),
                          _hoisted_40
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _hoisted_43,
                          _createElementVNode("div", _hoisted_44, [
                            _withDirectives(_createElementVNode("select", {
                              class: "o-select",
                              id: "date",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($data.selectedDate) = $event))
                            }, [
                              _hoisted_45,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.dates, (date) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: date.date
                                }, _toDisplayString(date.label), 9 /* TEXT, PROPS */, _hoisted_46))
                              }), 256 /* UNKEYED_FRAGMENT */))
                            ], 512 /* NEED_PATCH */), [
                              [_vModelSelect, $data.selectedDate]
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("button", {
                      onClick: _cache[8] || (_cache[8] = _withModifiers($event => ($options.reset()), ["prevent"])),
                      class: "o-form__button__reset"
                    }, " Réinitialiser ")
                  ])
                ]),
                _hoisted_48,
                _createElementVNode("div", _hoisted_49, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.tags, (tag) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("span", _hoisted_52, _toDisplayString(tag.label), 1 /* TEXT */),
                        _createElementVNode("button", {
                          onClick: _withModifiers($event => ($options.removeTag(tag)), ["prevent"]),
                          class: "o-filter__active__close"
                        }, _hoisted_55, 8 /* PROPS */, _hoisted_53)
                      ])
                    ]))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ])
              ], 32 /* NEED_HYDRATION */)
            ])
          ])
        ])
      ])
    ], 2 /* CLASS */)
  ]))
}